export const noop = (): void => {
    /* noop */
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const noopAsync = async () => {
    /* noop */
}
